<div class="error-wrapper">
    <app-svg-icon iconName="error"></app-svg-icon>
    <p class="error-content"><ng-content></ng-content></p>
</div>
